import React from 'react';

const Footer = () => {

    return (
        <div align='center' className='footer' style={{"background": "#ffffff"}}>
            <img className='footer-img' src="./a2i-logo-set.png" alt="Logo" />
            <br />
            Developed by
            <br />
            <img className='footer-img-sit' src="./synesisit_logo.png" alt="Logo" />
        </div>

    );
};


export default Footer;